import { useState, useEffect } from 'react'

export const useDetectPrint = () => {
  const [isPrinting, toggleStatus] = useState(false)

  useEffect(() => {
    const printMq = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('print')
    const mqEvent = (mqList) => toggleStatus(!!mqList.matches)

    printMq.addListener(mqEvent)
    return () => printMq.removeListener(mqEvent)
  })

  return isPrinting
}
